module.exports = require("mute-stream");


//////////////////
// WEBPACK FOOTER
// external "mute-stream"
// module id = 61
// module chunks = 0